import changelog from "../changelog.json";
import publicChangelog from "../publicChangelog.json";

const getLatestReleaseLogs = () => {
    let version;
    for (version in changelog.releases) {
        return changelog.releases[version];
    }

    return [];
};

const getLatestLog = () => {
    let logs = getLatestReleaseLogs();

    let log;
    for (log of logs) {
        return log;
    }

    return null;
};

export const getAll = () => {
    let latestLog = getLatestLog();
    if (latestLog === null) {
        return [
            {
                version: "0.0.0.0",
                message: "",
                date: ""
            }
        ];
    }

    if (publicChangelog.logs.length === 0) {
        return [
            {
                version: latestLog.version,
                message: "",
                date: latestLog === null ? "" : latestLog.date
            }
        ];
    }

    return publicChangelog.logs;
};

export const getLastClientVersion = () => {
    return changelog.version;
};

export const getLastClientRevision = () => {
    return changelog.rev;
};

export const getLastServerVersion = () => {
    let latestLog = getLatestLog();

    if (latestLog === null) {
        return "0.0.0.0";
    }

    return latestLog.server;
};

export const getLastRccVersion = () => {
    let latestLog = getLatestLog();

    if (latestLog === null) {
        return "0.0.0.0";
    }

    return latestLog.rcc;
};
